import { entitlementsSelectors } from 'app-components/flux/entitlements';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

import type { FeaturePage } from 'containers/App/paths';
import type { RootState } from 'store';

export const isNavItemVisible = (state: RootState, nav: FeaturePage): boolean =>
  (nav.accessSelector ? nav.accessSelector(state) : true) &&
  (nav.businessEnabled ? entitlementsSelectors.getBusinessEnabled(state) : true) &&
  (nav.featureFlag ? Boolean(featureFlagsSelectors.getFeatureFlag(state, nav.featureFlag)) : true) &&
  (nav.featureFlagHide ? !featureFlagsSelectors.getFeatureFlag(state, nav.featureFlagHide) : true);
